<template>
  <div class="uploadimg">
    <div class="addimg" :style="{height:height+'px'}" @click="cropperBox" v-if="!pic">
      <i class="el-icon-plus"></i>
      <p>点击上传</p>
    </div>
    <div>
      <div class="checkimgBody">
        <img :src="pic" alt="">
        <div class="checkimg-icon" @click="priviwe">
          <div class="checkimg-icon-box">
            <i class="el-icon-view"></i>
          </div>
        </div>
      </div>
      <p class="checkImgp mt-5" @click="cropperBox">重新选择图片</p>
    </div>
    <p class="infodescribe mt-5" v-if="page!=='startUp'">最佳尺寸为{{sizeBox[page].list[0]}}X{{sizeBox[page].list[1]}}像素，大小不超过2M，支持jpg、png格式</p>
    <corpper :visible.sync="corppervisible"
             v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="sizeBox[page].sizeType"></corpper>
    <viewImgDialog :privaImgObj="imgsrcCheck" :visible.sync="dialogImgVisible"></viewImgDialog>
  </div>
</template>
<script>
  import api from "@/api.js"
  import corpper from "@/components/dialog/corpper.vue";
  import viewImgDialog from "@/components/dialog/viewImgDialog.vue";

  export default {
    name: "uploadImg",
    props: ["imgNumber", "page","picSrc"],
    components: {
      corpper,
      viewImgDialog
    },
    watch:{
      picSrc(val){
        this.pic= this.picSrc
      }
    },
    data() {
      return {
        imgSize: 5,
        dialogImgVisible:false,
        corppervisible: false,
        imgsrcCheck:null,
        sizeBox: {
          'momentsEdit': {list:[686, 430],sizeType:5}, // 动态管理编辑
          'appletDesignInfomation': {list:[100, 100],sizeType:6}, // 官网装修你资讯添加
          'articleCreate':{list:[100, 100],sizeType:6}, //或可文章编辑
          'cardEdit':{list:[100, 100],sizeType:6}, // 名片管理编辑
          'moments':{list:[750, 668],sizeType:7}, // 动态管理动态设置
          'employeeEdit':{list:[100, 100],sizeType:6}, // 员工编辑
          'startUp':{list:[1080, 1620],sizeType:8},
          'goodsSpecificationDialog':{list:[100, 100],sizeType:6}, // 名片管理编辑
        },
        height: 0,
        pic: ''
      };
    },
    created() {
      // 机端比例尺寸内容，定义高度
      this.pic= this.picSrc
      if(this.sizeBox[this.page].list[0]>this.sizeBox[this.page].list[1]){
        this.height = (160 / this.sizeBox[this.page].list[0]) * this.sizeBox[this.page].list[1]
      }else if(this.sizeBox[this.page].list[0]<this.sizeBox[this.page].list[1]){
        this.height = (160 / this.sizeBox[this.page].list[1]) * this.sizeBox[this.page].list[0]
      }else{
        this.height = 160
      }

    },
    methods: {
      cropperBox() {
        this.corppervisible = true
      },
      imgAddBack(option) {
        this.pic = option
        this.$emit('getChildValue', option)
      },
      priviwe(){
        this.imgsrcCheck = this.pic
        this.dialogImgVisible = true
      }
    }
  };
</script>
<style>
  .addimg {
    width: 160px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #eee;
    border-radius: 4px;
    border: 1px #ddd dashed;
    cursor: pointer;
  }

  .addimg p {
    font-size: 12px;
    text-align: center;
    padding: 10 0;
  }

  .checkimgBody img {
    width: 160px;
    display: block;
  }
  .checkImgp{
    color:#578bcf ;
    font-size:12px;
    cursor: pointer;
    width: 100px;
  }
  .checkimgBody{
    width: 160px;
    position: relative;
  }
  .checkimgBody:hover .checkimg-icon{
    display: block;
  }
  .checkimg-icon{
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.3);
    cursor: pointer;
  }
  .checkimg-icon i{
    color:#fff
  }
  .checkimg-icon-box{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>

